import { Component, OnInit,Input } from '@angular/core';
import { ProjectService } from '../project.service';
@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.css']
})
export class ShowcaseComponent implements OnInit {
  projects;
  project1;
  project2;
  project3;
  project4;
  project5;
  constructor(private projectService:ProjectService) { }

  ngOnInit() {
    this.projects=this.projectService.getProjects();
    this.project1=this.projects[0];
    this.project2=this.projects[1];
    this.project3=this.projects[2];
    this.project4=this.projects[3];
    this.project5=this.projects[4];

  }

}
